module.exports = __webpack_public_path__ + "static/media/Michelle Morrison Headshot_1703003000047.ffec4c3b.jpeg";